module.exports = __webpack_public_path__ + "changelog-2-48b8c17a32ebb7e0e738e5f192eb8f48.webp";